const submitFormData = async (endpoint: string, formData: Record<string, unknown>) => {
  const baseUrl = process.env.NEXT_PUBLIC_CMS_BASE_URL?.replace(/\/+$/, '')
  if (!baseUrl) {
    throw new Error('CMS API is not configured. Set NEXT_PUBLIC_CMS_BASE_URL before submitting.')
  }

  const url = `${baseUrl}/${endpoint}`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    mode: 'cors',
    body: JSON.stringify({ data: formData })
  })

  if (response.ok) return true

  const responseBody = await response.text()
  let errorMessage: string | undefined

  try {
    const errorData: unknown = JSON.parse(responseBody)
    if (
      typeof errorData === 'object' &&
      errorData !== null &&
      'error' in errorData &&
      typeof errorData.error === 'object' &&
      errorData.error !== null &&
      'message' in errorData.error &&
      typeof errorData.error.message === 'string'
    ) {
      errorMessage = errorData.error.message
    }
  } catch {
    // Non-JSON bodies (such as an HTML error page) have no CMS message to extract.
  }

  const status = `${response.status}${response.statusText ? ` ${response.statusText}` : ''}`
  throw new Error(errorMessage || `Request to ${url} failed (${status})`)
}

export const submitForm = (formData: Record<string, unknown>) => {
  return submitFormData('enquiry-forms', formData)
}

export const submitReferralForm = (formData: Record<string, unknown>) => {
  return submitFormData('referral-forms', formData)
}
